import Vue from 'vue';
import App from './App';
import router from './router';

import minreset from 'minireset.css'; // 浏览器样式重设
import 'vant/lib/index.css';  //vant 样式
import commonless from './assets/css/common.less'; // 公共样式
import remjs from "./assets/scripts/rem"; // rem尺寸自适应调整
import axios from "./assets/scripts/api";
import cookie from 'vue-cookie'; // cookie
import uweb from 'vue-uweb'; // 友盟统计


cookie.install(Vue);

Vue.prototype.$http = axios;
Vue.http = axios;

Vue.config.productionTip = false;
Vue.use(uweb, { siteId: 1274259103});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,minreset,commonless,
  remjs,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js